<template>
  <div :class="[baseCss, disabled ? ['disabled', 'pointer-events-none'] : null]">
    <label :class="['block', 'w-full', 'cursor-pointer', paddingOff ? null : 'p-2']">
      <span :class="['whitespace-nowrap', 'truncate']">
        <avatar v-ripple :color="iconColor" :icon-provider="iconProvider" :color-lightness="iconColorLightness" :icon="icon" :icon-size="iconSize" :elevation="elevation" :class="['transition-all', 'duration-300']" :size="size" :tile="tile" :bg-color="prepareClassName" :bg-color-lightness="500" /><!--
      --><span v-if="label" v-html="valueToLowerCase" :class="['inline-block', paddingOff ? 'pl-1' : 'pl-2', 'align-middle', `text-${labelSize}`]" />
      </span>
      <input @input="$emit('input', $event.target.value)" :disabled="disabled" :value="valueToLowerCase" type="color" :class="['absolute', 'clip-0']" />
      <brand-color :name="prepareClassName" :hex="valueToLowerCase" />
    </label>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'ColorPicker',
  mixins: [
    methods
  ],
  data () {
    return {
      model: null,
      baseCss: this.componentBaseCss('color-picker', ['inline-block', 'align-middle', 'select-none'])
    }
  },
  computed: {
    prepareClassName () {
      return this.value.replace('#', '').toLowerCase()
    },
    valueToLowerCase () {
      return this.value.toLowerCase()
    }
  },
  props: {
    value: {
      type: String
    },
    paddingOff: {
      type: Boolean
    },
    tile: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: '40px'
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    elevation: {
      type: String,
      default: 'md'
    },
    disabled: {
      type: Boolean
    },
    label: {
      type: Boolean,
      default: true
    },
    labelSize: {
      type: String,
      default: 'sm',
      validator: value => {
        return ['xs', 'md', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', '8xl', '9xl'].includes(value)
      }
    },
    icon: {
      type: String
    },
    iconSize: {
      type: Number
    },
    iconColor: {
      type: String
    },
    iconColorLightness: {
      type: Number
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/color-picker/color-picker.vue